//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name:'QuicklyNav',
    props:{
        isBuy:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        goBuy(){
            this.$emit('clickBuy')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/quicklyNav.vue